// extracted by mini-css-extract-plugin
export var cardIcon = "_8s-5";
export var cardIconUnframed = "_8s-9";
export var checkboxCard = "_8s-0";
export var checkboxCardSelected = "_8s-4";
export var disabled = "_8s-2";
export var interactive = "_8s-1";
export var outerBorder = "_8s-3";
export var spacerMedium = "_8s-8";
export var spacerSmall = "_8s-7";
export var spacerXsmall = "_8s-6";